export const oneWayNotAllow = [''];
